import user from './modules/user';
import filter from './modules/filter';
import order from './modules/order';
import action from './modules/action';
import createPersistedState from 'vuex-persistedstate';

import getters from './getters';

export default {
  getters,
  modules: {
    user,
    filter,
    order,
    action
  },
  plugins: [
    createPersistedState()
  ],
  strict: true,
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/store.js